import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ValuationProcessComponent } from './valuation-process/valuation-process.component';
import { ValuationsComponent } from './valuations.component';

const routes: Routes = [
  { path:'', 
  component: ValuationsComponent,
  data: {
    title: 'Valuations'
  },
  children: [
    {
      path: ':valuationId',
      loadChildren: () => import('./view-valuation/view-valuation.module').then(m => m.ViewValuationModule)
    }
  ]
 }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ValuationsRoutingModule { }
